import React from 'react';
import { useGetAppConsentsQuery } from '../../api/appApiSlice';
import ConsentPie from '../metrics/ConsentPie';

const AppConsentPie = ( { source, title, appId, filter } ) => {
  const { data = [], isSuccess, isLoading, refetch } = useGetAppConsentsQuery({appId, filter})
  return (
    <ConsentPie title={title} source={source} data={data} loaderProps={{isSuccess, isLoading, retry: refetch}}/>
  )
}

export default AppConsentPie
